module.exports = __webpack_public_path__ + "media/site/images/products/eplaning-flat-screen@2x-e51cef6017d28c2ced4d282ee85e0741.png";